import { Component, Input } from '@angular/core';
import { JobContract } from '@models/models';

@Component({
	selector: 'contract-signature',
	template: require('./contract-signature.html'),
	styles: [require('./contract-signature.scss')]
})
export class ContractSignatureComponent {
	@Input() contract: JobContract;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/contract/contract-signature/contract-signature.ts